/**
 * Process-level registry that bridges TestRelicService → TestRelicReporter.
 *
 * Both service and reporter are instantiated by WDIO in the same worker process,
 * but WDIO never connects them automatically. Using `process` as the carrier
 * ensures the registry works even when service.ts and index.ts are built as
 * separate tsup bundles (each has its own module scope, but both share `process`).
 */

import type { TestRelicService } from './service.js';

const REGISTRY_KEY = '__testrelic_appium_service__';

export function registerService(s: TestRelicService): void {
  (process as Record<string, unknown>)[REGISTRY_KEY] = s;
}

export function getServiceInstance(): TestRelicService | null {
  return ((process as Record<string, unknown>)[REGISTRY_KEY] as TestRelicService) ?? null;
}

export function clearServiceRegistry(): void {
  delete (process as Record<string, unknown>)[REGISTRY_KEY];
}
